export const resolvePower = (number: number) => {
  const strNumber = number.toString();
  const ePosition = strNumber.search(/(e|E).+$/g);
  let ret = '';

  if (ePosition === -1) {
    ret = number.toString();
  } else {
    const positiveFloatLength = strNumber
      .slice(0, ePosition - 1)
      .replace('.', '').length;
    const ePower = ePosition === -1 ? 0 : +strNumber.slice(ePosition + 1);
    ret =
      ePower < 0
        ? number.toFixed(Math.abs(ePower) + positiveFloatLength)
        : number.toLocaleString('en-US').replaceAll(',', '');
  }

  return ret;
};

export const boundNumber = (
  numStr: string,
  opts?: { precision?: number; min?: string; max?: string },
) => {
  const min = opts?.min ?? numStr;
  const max = opts?.max ?? numStr;

  if (+numStr < +min) numStr = min;
  if (+numStr > +max) numStr = max;

  const ePosition = numStr.search(/(e|E).+$/g);
  let ret = '';

  if (ePosition === -1) {
    ret = numStr;
  } else {
    const positiveFloatLength = numStr
      .slice(0, ePosition - 1)
      .replace('.', '').length;
    const ePower = ePosition === -1 ? 0 : +numStr.slice(ePosition + 1);
    ret =
      ePower < 0
        ? (+numStr).toFixed(Math.abs(ePower) + positiveFloatLength)
        : (+numStr).toLocaleString('en-US').replaceAll(',', '');
  }

  const precision = opts?.precision ?? -1;
  if (precision >= 0) {
    let [basePart, precisionPart] = ret.split('.');
    precisionPart = precisionPart?.slice(0, precision) ?? '';
    ret = `${basePart}${precisionPart ? '.' : ''}${precisionPart}`;
  }

  return ret;
};

export const toDigits = (numStr: string) =>
  numStr
    .replace(/[٠١٢٣٤٥٦٧٨٩۰۱۲۳۴۵۶۷۸۹]/g, (d: string) =>
      String.fromCharCode((d.charCodeAt(0) & 15) + 48),
    )
    .replace(/[^\d.]/g, '');

export const fixShape = (numStr: string) => {
  if (numStr.startsWith('.')) numStr = `0.${numStr}`;
  if (/^0+\d/.test(numStr)) numStr = numStr.replace(/^0+/, '');
  if (numStr === '' || numStr.startsWith('.')) numStr = `0.${numStr}`;
  numStr = numStr.replace(/\.(?=.*\.)/g, '');
  return numStr;
};

export const addComma = (numStr: string) => {
  const add = (str: string) =>
    str.length > 3
      ? (
          str
            .split('')
            .reverse()
            .join('')
            .match(/.{1,3}/g)
            ?.join(',') ?? ''
        )
          .split('')
          .reverse()
          .join('')
      : str;
  if (numStr.includes('.')) {
    const [base, precision] = numStr.split('.');
    numStr = `${add(base)}.${precision}`;
  } else {
    numStr = add(numStr);
  }
  return numStr;
};

export const abbreviate = (numStr: string) => {
  const num = +toDigits(numStr);
  if (Number.isNaN(num)) return numStr;
  if (num >= 1_000_000_000_000) {
    const trillions = num / 1_000_000_000_000;
    return `${trillions.toFixed(1).replace(/\.0$/, '')}T`;
  }
  if (num >= 1_000_000_000) {
    const billions = num / 1_000_000_000;
    return `${billions.toFixed(1).replace(/\.0$/, '')}B`;
  }
  if (num >= 1_000_000) {
    const millions = num / 1_000_000;
    return `${millions.toFixed(1).replace(/\.0$/, '')}M`;
  }
  return num.toString();
};

// export const cut = (numStr: string) => {
//   const [base, decimalStr = ''] = numStr.split('.');
//   if (!decimalStr || +decimalStr === 0) return base;
//   return `${base}.${decimalStr.replaceAll(/0*$/g, '')}`;
// };
